var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2537_9941)",
    filter: "url(#filter0_d_2537_9941)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9532 37.3474C35.3799 40.1853 30.8581 41.8806 25.9404 41.8806C14.3752 41.8806 5 32.505 5 20.9399C5 9.37483 14.3752 -0.000671387 25.9404 -0.000671387C37.5055 -0.000671387 46.8807 9.37483 46.8807 20.9399C46.8807 25.8577 45.1855 30.3796 42.3476 33.953L53.0004 44.6061L49.6061 48.0004L38.9532 37.3474ZM25.9404 37.0802C34.8543 37.0802 42.0804 29.854 42.0804 20.9399C42.0804 12.0259 34.8543 4.79964 25.9404 4.79964C17.0265 4.79964 9.80031 12.0259 9.80031 20.9399C9.80031 29.854 17.0265 37.0802 25.9404 37.0802ZM30.3422 33.6217L31.8424 32.4896L29.6643 29.5913L29.6656 29.5897L26.0513 24.7805L26.0489 24.7806L23.9845 22.0336L23.9867 22.0332L22.0407 19.4437L22.0387 19.4444L20.1434 16.9224L20.1453 16.9217L17.9945 14.0597L17.9926 14.0605L15.365 10.5642L13.8648 11.6963L16.2637 14.8884C14.6441 15.7498 13.6031 16.5565 13.2645 16.8188C13.2322 16.8438 13.2062 16.8639 13.1868 16.8786L15.4242 19.672C16.3412 18.9257 17.3345 18.27 18.3906 17.7185L20.2296 20.1655C19.1797 20.6682 18.199 21.293 17.306 22.0214L19.1877 24.3707C20.0575 23.659 21.0322 23.0713 22.0851 22.6346L23.9761 25.1508C22.9019 25.4837 21.9178 26.0221 21.0695 26.7201L26.5053 33.5067L26.5168 33.5181L26.5282 33.5067L28.4513 31.1057L30.3422 33.6217ZM31.964 26.7201L30.775 28.2046L28.3381 24.9619C29.6934 25.2552 30.9297 25.8689 31.964 26.7201ZM26.5168 21.7557C26.3231 21.7557 26.1305 21.7605 25.9392 21.7699L23.848 18.9872C24.7133 18.8271 25.6053 18.7434 26.5168 18.7434C30.0091 18.7434 33.215 19.972 35.7276 22.0213L33.8458 24.3707C31.8483 22.7361 29.2968 21.7557 26.5168 21.7557ZM26.5168 15.7311C24.9076 15.7311 23.3489 15.9474 21.868 16.3526L19.6654 13.4218C21.6015 12.7698 23.9115 12.2884 26.5168 12.2884C33.9168 12.2884 38.9485 16.1836 39.7707 16.8201L39.7715 16.8207C39.8026 16.8448 39.8279 16.8644 39.8467 16.8786L37.6093 19.672C34.5816 17.2078 30.7213 15.7311 26.5168 15.7311Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2537_9941",
    x: -4,
    y: 0,
    width: 66,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2537_9941"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2537_9941",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2537_9941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.6fbefc565829fd36035533767ef441f2.svg";
export { ForwardRef as ReactComponent };